"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = exports.columnsPropType = exports.columnPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@mmc/text");
var columnPropType = _propTypes["default"].shape({
  image: _propTypes["default"].shape({
    image: _propTypes["default"].string
  }),
  description: _propTypes["default"].shape({
    sectionHeading: _propTypes["default"].string,
    mainHeading: _propTypes["default"].string,
    paragraph: _propTypes["default"].string
  }),
  link: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    label: _propTypes["default"].string,
    priority: _propTypes["default"].string,
    openNewTab: _propTypes["default"].bool
  }),
  link2: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    label: _propTypes["default"].string,
    priority: _propTypes["default"].string,
    openNewTab: _propTypes["default"].bool
  }),
  link3: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    label: _propTypes["default"].string,
    priority: _propTypes["default"].string,
    openNewTab: _propTypes["default"].bool
  })
});
exports.columnPropType = columnPropType;
var columnsPropType = _propTypes["default"].arrayOf(columnPropType);
exports.columnsPropType = columnsPropType;
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  editorialLayout: _propTypes["default"].string,
  columns: columnsPropType,
  disclaimerData: _text.disclaimerDataPropTypes
});
var _default = PROP_TYPES;
exports["default"] = _default;